/**
 * ERP Pro API — inbox, rewards, reviews, aiScore.
 */

import { apiFetch } from './core'

export const erpPro = {
    inbox: {
        list: (employeeId, showCompleted = false) => apiFetch(`/erp-pro/inbox/${employeeId}?show_completed=${showCompleted}`),
        stats: (employeeId) => apiFetch(`/erp-pro/inbox/${employeeId}/stats`),
        create: (data) => apiFetch('/erp-pro/inbox', {
            method: 'POST',
            body: JSON.stringify(data),
        }),
        markRead: (itemId) => apiFetch(`/erp-pro/inbox/${itemId}/read`, { method: 'PATCH' }),
        complete: (itemId) => apiFetch(`/erp-pro/inbox/${itemId}/complete`, { method: 'PATCH' }),
        seedDemo: (employeeId) => apiFetch(`/erp-pro/inbox/seed-demo/${employeeId}`, { method: 'POST' }),
    },
    rewards: {
        list: () => apiFetch('/erp-pro/rewards'),
        create: (data) => apiFetch('/erp-pro/rewards', {
            method: 'POST',
            body: JSON.stringify(data),
        }),
        seedCatalog: () => apiFetch('/erp-pro/rewards/seed-catalog', { method: 'POST' }),
        balance: (employeeId) => apiFetch(`/erp-pro/rewards/balance/${employeeId}`),
        redeem: (data) => apiFetch('/erp-pro/rewards/redeem', {
            method: 'POST',
            body: JSON.stringify(data),
        }),
    },
    reviews: {
        list: (params = {}) => {
            const qs = new URLSearchParams(params).toString()
            return apiFetch(`/erp-pro/reviews${qs ? `?${qs}` : ''}`)
        },
        get: (id) => apiFetch(`/erp-pro/reviews/${id}`),
        create: (data) => apiFetch('/erp-pro/reviews', {
            method: 'POST',
            body: JSON.stringify(data),
        }),
        submit: (id) => apiFetch(`/erp-pro/reviews/${id}/submit`, { method: 'POST' }),
        acknowledge: (id) => apiFetch(`/erp-pro/reviews/${id}/acknowledge`, { method: 'POST' }),
        finalize: (id, payload) => apiFetch(`/erp-pro/reviews/${id}/finalize`, {
            method: 'POST',
            body: JSON.stringify(payload),
        }),
    },
    positionTransfers: {
        list: (employeeId) => apiFetch(`/erp-pro/employees/${employeeId}/position-transfers`),
        create: (employeeId, payload) => apiFetch(`/erp-pro/employees/${employeeId}/position-transfers`, {
            method: 'POST',
            body: JSON.stringify(payload),
        }),
    },
    aiScore: (data) => apiFetch('/erp-pro/ai/score-resume', {
        method: 'POST',
        body: JSON.stringify(data),
    }),
}
